export const CLAIMS_TASKS = 'CLAIMS_TASKS';
export const CLAIMS_TASKS_DETAIL_LIST = 'CLAIMS_TASKS_DETAIL_LIST';
export const CLAIMS_USER_LIST = 'CLAIMS_USER_LIST';
export const CLAIMS_STATISTICS = 'CLAIMS_STATISTICS';
